// JavaScript Document

// ---- FAQセクションの検索窓（質問・回答の部分一致でフィルタ）----
function initFaqSearch() {
  document.querySelectorAll('.faq[data-search-enabled]').forEach(function (faq) {
    if (faq.dataset.faqSearchInit) return;
    faq.dataset.faqSearchInit = 'true';

    const wrapper = faq.closest('.section-stack');
    const input = wrapper ? wrapper.querySelector('.faq__search input') : null;
    const noResults = wrapper ? wrapper.querySelector('.faq__search-no-results') : null;
    const items = faq.querySelectorAll('[data-search-text]');
    const categories = faq.querySelectorAll('.faq__category');

    if (!input) return;

    input.addEventListener('input', function () {
      const term = input.value.trim().toLowerCase();
      let visibleCount = 0;

      items.forEach(function (item) {
        const text = item.dataset.searchText || '';
        const match = term === '' || text.includes(term);
        item.hidden = !match;
        if (match) visibleCount += 1;
      });

      categories.forEach(function (category) {
        if (term === '') {
          category.hidden = false;
          return;
        }

        let hasVisibleQuestion = false;
        let next = category.nextElementSibling;

        while (next && !next.classList.contains('faq__category')) {
          if (next.hasAttribute('data-search-text') && !next.hidden) {
            hasVisibleQuestion = true;
            break;
          }
          next = next.nextElementSibling;
        }

        category.hidden = !hasVisibleQuestion;
      });

      if (noResults) {
        noResults.hidden = visibleCount > 0;
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', initFaqSearch);
